import { useReducedMotion } from 'motion/react';

/**
 * Motion rules (dark luxe)
 * ─────────────────────
 * Hero:           animate on mount only — staggerContainer + clipUp for name
 * Section headers: whileInView once — MotionReveal (fadeUp)
 * Project rail:   whileInView once — railStaggerContainer + railStaggerItem
 * Buttons:        MotionButton scale 1.02 hover / 0.98 tap
 * Modal:          modalBackdrop + modalDialog spring
 *
 * Disabled: orbs, grid, 3D rotate, card lift, stacked parallax
 * Reduced motion: static render, no Lenis, no scroll progress
 */

/** Premium spring — buttons, modals */
export const spring = { type: 'spring', stiffness: 300, damping: 28 };

/** Softer spring — rail slides, sections */
export const springSoft = { type: 'spring', stiffness: 220, damping: 30 };

/** Hero + section headers: use animate on mount (priority) or whileInView once */
export const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

/** Hero name only — mount animation */
export const clipUp = {
  hidden: { opacity: 0, y: 40, clipPath: 'inset(100% 0 0 0)' },
  visible: {
    opacity: 1,
    y: 0,
    clipPath: 'inset(0% 0 0 0)',
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
  },
};

export const staggerContainer = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.08, delayChildren: 0.05 },
  },
};

export const staggerItem = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: spring },
};

/** Project showcase rail */
export const railStaggerContainer = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.1, delayChildren: 0.04 },
  },
};

export const railStaggerItem = {
  hidden: { opacity: 0, x: 28 },
  visible: { opacity: 1, x: 0, transition: springSoft },
};

export const modalBackdrop = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
  exit: { opacity: 0 },
};

export const modalDialog = {
  hidden: { opacity: 0, y: 40, scale: 0.97 },
  visible: { opacity: 1, y: 0, scale: 1, transition: spring },
  exit: { opacity: 0, y: 24, scale: 0.98, transition: { duration: 0.2 } },
};

export function usePrefersReducedMotion() {
  return useReducedMotion();
}
